export default {
  title: 'Blokada karty',
  properties: {
    blockEndDate: {
      title: 'Data końca blokady',
      type: 'string',
      format: 'date',
      fieldRequired: true,
      validationMessages: {
        required: 'Data końca blokady jest wymagana.'
      }
    }
  }
};
